import { useState } from "react";
import Header from "../../components/shared/Widget/Header/Header";
import "./LandingLayout.scss";
import { Outlet } from "react-router-dom";
import { LOGIN_LITERALS } from "../../constants/literals";
import SideNav from "../../components/shared/Widget/Side-nav/Side-nav";
import { useAuth } from "../../context/AuthProvider";
import { Roles } from "../../constants/data/Roles";

function LandingLayout() {
  const [mobileToggle, setMobileToggle] = useState<boolean>(false);
  const [isSideNavOpen, setIsSideNavOpen] = useState<boolean>(false);
  const auth = useAuth();

  function mobileMenuToggle() {
    if (mobileToggle) {
      setMobileToggle(false);
    } else {
      setMobileToggle(true);
    }
  }
  const userRole = auth?.authClaims?.role || "";
  return (
    <div
      className={
        "d-flex admin-content-wrapper " + (mobileToggle ? "show-menu" : "")
      }
    >
      {mobileToggle}
      <div
        className={"admin-left-wrapper " + (isSideNavOpen ? "" : "inactive")}
      >
        <div
          className="hamburger-icon pr-4 pt-4 text-right cursor-pointer"
          onClick={mobileMenuToggle}
        >
          <span className="nav-menu-close">{/* <Close /> */}</span>
        </div>

        {(userRole.toUpperCase() === Roles.supportUser ||
          userRole.toUpperCase() === Roles.superUser) && (
          <div>
            <SideNav
              isSideNavOpen={isSideNavOpen}
              setIsSideNavOpen={setIsSideNavOpen}
            />
          </div>
        )}
      </div>
      {
        <Header
          userName="superadmin@techigai.io"
          role="Support user"
          setIsSideNavOpen={(e) => {
            setIsSideNavOpen(e);
          }}
          isActive={isSideNavOpen}
        />
      }
      <div
        className={"admin-right-wrapper " + (isSideNavOpen ? "" : "inactive")}
      >
        <div
          onClick={mobileMenuToggle}
          className="nav-menu-open header-badge-wrapper"
        >
          <span className="material-icons nav-menu-open-icon">
            {/* <Menu /> */}
          </span>
        </div>
        <div className="admin-main-content h-100">
          <div className="admin-main-wrapper">
            <Outlet />
          </div>
          <div className="support">
            <div className="copy-rights-wrapper d-flex justify-content-between">
              <div className="copy-rights-content">
                {LOGIN_LITERALS.copyRights}
              </div>
              <div className="d-flex gap-4 privacy-policy-wrapper">
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_TERMS_URL);
                  }}
                >
                  Terms of Use
                </span>
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_PRIVACY_URL);
                  }}
                >
                  Privacy Policy
                </span>
                <span
                  className="link"
                  onClick={() => {
                    window.open(process.env.REACT_APP_SUPPORT_LINK);
                  }}
                >
                  Support
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LandingLayout;
